export default __webpack_public_path__ + "200b7be.png";